<p class="text-18 is-family-medium">
  <ng-content></ng-content>
</p>